export const LED_SETTINGS_STORAGE_KEY = 'futbol-fighters-led-settings-v1';

export interface LedSettings {
  rotate: boolean;
  interval: number;
  transition: 'cut' | 'fade' | 'wipe' | 'slide';
  duration: number;
  blink: number;
  blinkRate: number;
  sweep: boolean;
  colorCycle: boolean;
  pixels: boolean;
}

export const DEFAULT_LED_SETTINGS: Readonly<LedSettings> = {
  rotate: true, interval: 6, transition: 'wipe', duration: 0.28,
  blink: 58, blinkRate: 9, sweep: true, colorCycle: true, pixels: true,
};

export function normalizeLedSettings(value: unknown): LedSettings {
  const source = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  const number = (key: keyof LedSettings, min: number, max: number): number => {
    const n = source[key];
    return typeof n === 'number' && Number.isFinite(n) ? Math.max(min, Math.min(max, n)) : DEFAULT_LED_SETTINGS[key] as number;
  };
  const flag = (key: 'rotate' | 'sweep' | 'colorCycle' | 'pixels'): boolean => typeof source[key] === 'boolean' ? source[key] as boolean : DEFAULT_LED_SETTINGS[key];
  const interval = number('interval', 2, 30);
  return {
    rotate: flag('rotate'), interval,
    transition: ['cut', 'fade', 'wipe', 'slide'].includes(source.transition as string) ? source.transition as LedSettings['transition'] : 'wipe',
    duration: Math.min(number('duration', 0.1, 2), interval / 2),
    blink: number('blink', 0, 100), blinkRate: number('blinkRate', 1, 10),
    sweep: flag('sweep'), colorCycle: flag('colorCycle'), pixels: flag('pixels'),
  };
}

function load(): LedSettings {
  try { return normalizeLedSettings(JSON.parse(localStorage.getItem(LED_SETTINGS_STORAGE_KEY) ?? 'null')); }
  catch { return normalizeLedSettings(null); }
}

let current = load();
export function getLedSettings(): Readonly<LedSettings> { return current; }
export function saveLedSettings(value: unknown): { settings: Readonly<LedSettings>; persisted: boolean } {
  current = normalizeLedSettings(value);
  try {
    localStorage.setItem(LED_SETTINGS_STORAGE_KEY, JSON.stringify(current));
    return { settings: current, persisted: true };
  } catch { return { settings: current, persisted: false }; }
}
